import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React, { useMemo } from "react";

import { Box, Flex } from "~/components/blocks";

import { StepName, StepNameMap } from "../types";
import { Step } from "./Step";

export const STEPS: StepName[] = [
  StepNameMap.time,
  StepNameMap.prescription,
  StepNameMap.patientInfo,
  StepNameMap.questionnaire,
  StepNameMap.complete,
];

type Props = {
  currentStep: StepName;
};

const Wrap = styled(Box)(({ theme }) =>
  css({
    width: "100%",
    maxWidth: theme.windowSize.base,
    margin: `${theme.space.l} auto 0`,
    padding: "0",
    boxSizing: "border-box",
    [`@media ${theme.mediaQueries.sp}`]: {
      margin: `0 auto`,
    },
  }),
);

export const Stepper = React.memo((props: Props) => {
  const { currentStep } = props;
  const theme = useTheme();

  const stepper = useMemo(() => {
    const _stepper: { [key: string]: boolean } = {
      [StepNameMap.prescription]: false,
      [StepNameMap.patientInfo]: false,
      [StepNameMap.questionnaire]: false,
    };

    let isProgressed = true;
    for (const _step of STEPS) {
      _stepper[_step] = isProgressed;

      if (_step === currentStep) {
        isProgressed = false;
      }
    }

    return _stepper;
  }, [currentStep]);

  return (
    <Wrap>
      <Flex justifyContent="space-around" marginY={theme.space.l}>
        <Step label="処方箋" active={stepper.prescription} />
        <Step label="患者情報" active={stepper.patientInfo} />
        <Step label="問診" active={stepper.questionnaire} />
      </Flex>
    </Wrap>
  );
});

Stepper.displayName = "Stepper";
